import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';
import { NgSelectModule } from '@ng-select/ng-select';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ThemeSettingsComponent } from './theme-settings/theme-settings.component';
import { ThemeSettingsRoutingModule } from './theme-settings-routing.module';
import { EditPartnerSettingsComponent } from './components/edit-partner-theme-settings/edit-partner-settings.component';
import { AddNewThemeComponent } from './components/add-new-partner-theme-settings/add-new-theme.component';
import { ListPartnersSettingsComponent } from './components/list-partners-settings/list-partners-settings.component';
import { LottiePreviewComponent } from './components/lottie-preview/lottie-preview.component';

@NgModule({
  imports: [
    CommonModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    ThemeSettingsRoutingModule,
    MatMenuModule,
    SharedModule,
    MatIconModule,
    MatTooltipModule,
    MatSlideToggleModule
  ],
  declarations: [
    ThemeSettingsComponent,
    ListPartnersSettingsComponent,
    EditPartnerSettingsComponent,
    AddNewThemeComponent,
    LottiePreviewComponent
  ]
})
export class ThemeSettingsModule {}
